import { twMerge } from "tailwind-merge";

export default function HomeIcon({ fill = "#808080", className, ...props }) {
  const defaultClasses = "w-4 h-4";
  const mergedClassName = twMerge(defaultClasses, className);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      className={mergedClassName}
      viewBox="0 0 29 28"
      {...props}
    >
      <path d="M25 12.6384V22.7501C25 23.2142 24.8156 23.6593 24.4874 23.9875C24.1592 24.3157 23.7141 24.5001 23.25 24.5001H18.875C18.4109 24.5001 17.9658 24.3157 17.6376 23.9875C17.3094 23.6593 17.125 23.2142 17.125 22.7501V18.3751C17.125 18.143 17.0328 17.9205 16.8687 17.7564C16.7046 17.5923 16.4821 17.5001 16.25 17.5001H12.75C12.5179 17.5001 12.2954 17.5923 12.1313 17.7564C11.9672 17.9205 11.875 18.143 11.875 18.3751V22.7501C11.875 23.2142 11.6906 23.6593 11.3624 23.9875C11.0342 24.3157 10.5891 24.5001 10.125 24.5001H5.75C5.28587 24.5001 4.84075 24.3157 4.51256 23.9875C4.18437 23.6593 4 23.2142 4 22.7501V12.6384C3.99996 12.3962 4.0502 12.1566 4.14754 11.9348C4.24487 11.713 4.38719 11.5139 4.56547 11.3499L13.3155 3.09431L13.3275 3.08228C13.6497 2.7893 14.0695 2.62695 14.5049 2.62695C14.9404 2.62695 15.3602 2.7893 15.6823 3.08228C15.6861 3.08656 15.6901 3.09058 15.6944 3.09431L24.4444 11.3499C24.6209 11.5147 24.7614 11.7143 24.857 11.936C24.9526 12.1578 25.0013 12.3969 25 12.6384Z" />
    </svg>
  );
}
